import React, {Component} from "react";
import PropTypes from "prop-types";
import {arrayMove} from "react-sortable-hoc";
import SortableQuizContainer from './SortableQuizContainer';

class SortableQuiz extends Component {
    state = {
        questions: [...this.props.questions]
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        let {questions} = this.state;
        questions = arrayMove(this.state.questions, oldIndex, newIndex);
        this.setState({questions}, () => {
            this.state.questions.map((q,i) => {
                q.number = i;
            });
            
            this.props.updateQuestionNumbers(this.state.questions);
        });
    };

    //Lifecycle
    componentWillReceiveProps(nextProps) {
        if (this.state.questions != nextProps.questions) {
            this.setState({questions: nextProps.questions});
        }
    };

    render() {
        return (
            <SortableQuizContainer
                
                onSortEnd={this.onSortEnd}
                questions={this.state.questions}
                handleEditQuestionClick={this.props.handleEditQuestionClick}
                handleDeleteModalShowState={this.props.handleDeleteModalShowState}
                handleRewindTo={this.props.handleRewindTo}
                isEditedInPreview={this.props.isEditedInPreview}
                uploadQuestions={this.props.uploadQuestions}


            />
        );
    }
}

export default SortableQuiz;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/SortableQuiz.js